<template>
    <div class="msgs-menu" v-on:mouseleave="mouseleave" v-on:mouseover="mouseover">
        <div class="msgsScroll">
            <!-- 
              PWS_WaitingForDoctoreApproval 
              https://mflow-do-dev.mis-implants.com/mflow/_msg.aspx?order=5000350&sid=21
            -->

            <!-- No notifications -->
            <div v-if="notifications.length==0" class="emptyList">No Notifications</div>
            
            <!-- Has notifications -->
            <div v-if="notifications.length>0">

                <div v-for="item in notifications" @click="closePanel" :key="item.msg_id" 
                    :class="['msgItem',locale=='HE' ? 'rtl':'',{ new:item.msg_status==0}]">
                    <div class="msgDate" v-text="getMsgDate(item)"></div>
                    <div class="msgText" v-html="getMsgText(item)"></div>

                    <template v-if="isItemNeedSchedule(item)">
                      <a 
                        class="msgBtn scheduleLink" 
                        v-for="scheduleLink in _USA_SCHEDULE_LINKS" 
                        :key="scheduleLink.name"                        
                        :href="scheduleLink.url">
                          {{scheduleLink.name}}
                      </a>

                      <!--
                      <router-link class="msgBtn" style="margin-left:0px;" to="/schedule?owner=18623885&calendarID=3416556">Melanie</router-link>
                      <a class="msgBtn" style="margin-left:8px;" href="https://app.acuityscheduling.com/schedule/0a71a7e0/appointment/12083997/calendar/5966565?appointmentTypeIds%5B%5D=12083997">Mike</a>
                      -->
                    </template>
                    
                    <template v-else-if="isCoreFileMsg(item)">
                      <!-- DOWNLOAD CORE FILE BUTTON -->
                      <a class="msgBtn"
                        :href="`${serverAPI}mflow/OrderFileDownloadCoreFile/${item.order_id}`"
                        target="_blank">{{localize('download')}}</a>
                    </template>

                    <template v-else-if="isItemBlockedFilesMsg(item)">
                      <!-- ORDER HAS BLOCKED FILE ! FIX IT -->
                      <div v-if="item.IssueResolved==false" @click="gotoOrderEditPage(item)" class="msgBtn">{{localize('edit_order')}}</div>
                      <div v-else class="approved"><i class="fal fa-check"></i> {{localize('Updated')}}</div>
                    </template>

                    <template v-else-if="isItemNeedApproval(item) && !isItemApproved(item)">
                      <!-- APPROVE ORDER BUTTON -->
                      <div @click="gotoApprovalPage(item)"
                        class="msgBtn">
                        {{localize('approve')}}</div>
                    </template>

                    <template v-else-if="isItemNeedApproval(item) && isItemApproved(item)">
                      <!-- APPROVED ALREADY (no action) -->
                      <div class="approved">
                        <i class="fal fa-check"></i> 
                        {{localize('approved')}}
                      </div>
                    </template>

                </div>
            </div>
            <!--msg_status {{notifications}}-->
        </div>
    </div>
</template>

<script>
//import { USA_SCHEDULE_LINKS } from '../client.config.js';

import ClickOutside from "vue-click-outside";
import { mapState, mapGetters, mapActions } from "vuex";
import { relativeTimeRounding } from 'moment';
export default 
{
  data() {
    return {
        isMouseOver:true,
        notificationsMenuActive: false,
        hasNotifications: false
    };
  },
  watch: {
      //....
  },
  directives: {
    ClickOutside
  },
  mounted() {
    document.addEventListener('click', this.onClick);
  },
  destroyed() {
    document.removeEventListener('click', this.onClick);
  },
  methods: {
    ...mapActions(["loadNotifications","markNotificationsAsRead"]),
    IsUSA()
    {
      return this.user.Country === "226" ? true : false;
    },
    isCoreFileMsg(item)
    {
        return item.msg_type == 2 ? true : false;
    },
    isItemBlockedFilesMsg(item)
    {
        return item.msg_type == 3 ? true : false;
    },
    isItemNeedApproval(item)
    {
      var vm=this;
      var needApproval = false;
      if(item.order_new_status == 21 && vm.user.IsPwsUser===true){
        needApproval=true;
      }
      if(item.order_new_status == 2 && vm.user.IsPwsUser!=true){
        needApproval=true;
      }
      return needApproval;
    },
    isItemNeedSchedule(item)
    {
        return item.order_new_status==2 && this.IsUSA();
    },
    isItemApproved(item)
    {
        let AlreadyApproved = false;
        if(item.DidDoctorApprove && item.DidDoctorApprove==true){
          AlreadyApproved=true;
        }
        return AlreadyApproved;
    },
    markUnreadAsRead()
    {
        //Notify server on messages ststus change
        var vm = this;
        var unreadMsgsIDs = [];
        for (var i=0;i<vm.notifications.length;i++){
            if(vm.notifications[i].msg_status == 0){
                unreadMsgsIDs.push(vm.notifications[i].msg_id);
            }
        }        
        console.log("unreadMsgsIDs>>>"+unreadMsgsIDs);
        if(unreadMsgsIDs.length>0){
          vm.markNotificationsAsRead(unreadMsgsIDs);
        }

        //if all messages are in 'read' (1) status do nothing,
        //if some of the messages are in 'sent' status (0) then:          
        //collect all these unread (0) messages and post to server to change the status
        //Change the whole array msg_status to 1
        //for (var i=0;i<vm.notifications.length;i++){
            //vm.notifications[i].msg_status=1;//set to read
        //}
    },
    closePanel()
    {
        this.markUnreadAsRead();
        this.$emit("closed");
    },
    onClick()
    {
      var vm=this;
      if(!this.isMouseOver){
        vm.closePanel();
      }
    },
    mouseover(){
      this.isMouseOver=true;
    },
    mouseleave(){
        this.isMouseOver=false;
    },
    gotoOrderEditPage(item)
    {
        this.closePanel();
        var routePath =  "/order/"+item.order_id;
        this.$router.replace(routePath);        
    },
    gotoApprovalPage(item){       
        this.closePanel();
        var routePath =  "/order/"+item.order_id+"/approval";
        this.$router.replace(routePath);        
    },
    getMsgDate(item){
        return item.date_created.substring(0, 10);
    },
    getMsgText(item){
        var text = "";
        let baseText = '';

        if(item.msg_type==3)
        {
          baseText = this.localize('order_xxx_contains_blocked_files');   
        }
        if(item.msg_type==2)
        {
          //Core file uploaded message
          baseText = 'Order xxxx '+ this.localize('core_file_ready_for_you');   
          //click to download ????x     
        }
        if(item.msg_type==1)
        {
          //status change message
          if(item.order_new_status==7){
            //text = "<span class='orderNum'>Order "+item.order_id+"</span> was put On Hold, an email is being sent to you with details.";
            baseText = this.localize('order_xxx_was_put_on_hold');        
          }
          if(item.order_new_status==21 || item.order_new_status==2){  
            //text = "<span class='orderNum'>Order "+item.order_id+"</span> is waiting for your approval.";
            baseText = this.localize('order_xxx_is_waiting_for_approval');        
          }
          if(item.order_new_status==1){
            baseText = 'Order xxxx '+ this.localize('was received with thanks. We will review it and contact you shortly.');        
          }
          if(item.order_new_status==2 && this.IsUSA()){
            //text = "<span class='orderNum'>Order "+item.order_id+"</span> Please schedule a review session with your planner:";
            //baseText = this.localize('order xxx Please schedule a review session with your planner:');        
            baseText = this.localize('order_xxx_please_schedule');        
            //tag:order_xxx_please_schedule
            //en:Order xxx - Please schedule a review session with your planner
            //de:Bestellung xxx - Bitte vereinbaren Sie eine Überprüfungssitzung mit Ihrem Planer
            //es:Pedido xxx - Programe una sesión de revisión con su planificador
            //ru:порядок xxx - Пожалуйста, запланируйте обзорную сессию с вашим планировщиком
            //fr:Commande xxx - Veuillez planifier une séance d'examen avec votre planificateur
          }
        }
        text = baseText;
        text = text.replace("xxxx","<span class='orderNum'>"+item.order_id+"</span>")
        return text;
    }
  },
  computed: {
    ...mapState(["user", "$device","notifications","locale","_USA_SCHEDULE_LINKS"]),
    ...mapGetters(["isMcenter", "isDistributor"]),
    serverAPI() {
      return SERVER_API[ENV];
    },

  }
};
</script>

<style>
  .orderNum
  {
      font-weight: 500 !important;
  }
</style>

<style scoped>

  .msgsScroll
  {
    clear: both;
    background-color: #f7fcff;
    min-height: 100vh;
  }

    .emptyList
    {
        padding: 30px;
        text-align: center;
    }

  .msgItem
  {
    padding: 20px;
    list-style: none;
    clear: both;
    border-bottom: solid 1px #bde3fd;
    background-color: #f7fcff;
  }
  .msgItem.rtl
  {
    direction: rtl;
  }
  .msgItem.new 
  {
    background-color: #d8efff;
  }
  .msgDate
  {
    clear: both;
    font-size: 11px;
    display: block;
    color:#0076c0;
    font-weight: 800;
  }
  .msgText
  {
    clear: both;
    font-size: 14px;
    display: block;
    padding-top: 5px;
  }
  .msgBtn
  {
    background-color: #0076c0;
    font-size: 11px;
    color:#fff;    
    display: inline;
    padding: 2px 12px;
    position: relative;
    top: 3px;
    font-weight: 500;
    cursor: pointer;
  }
  .msgBtn:hover
  {
    color:#fff !important;
    background-color: #1c87cf !important;
  }
  .scheduleLink
  {
    margin-right: 8px;
  }
  .approved
  {
    background-color: green;
    font-size: 11px;
    color:#fff;    
    display: inline;
    padding: 2px 12px;
    position: relative;
    top: 3px;
    font-weight: 500;
    cursor: initial;
    pointer-events: none;

  }
</style>

<style lang="stylus" scoped>
  .notifications
    translate3d(0,0,0)
    transform-style preserve-3d
    position relative
    background-color #f7fcff
    z-index 213
    i
      color #fff
      font-size responsive 14px 28px
      -webkit-text-stroke 1px #0076c0
    &.has-notifications:before
      content ''
      round(10)
      position absolute
      top 0
      left 60%
      background green_2

</style>
